@file:OptIn(InternalResourceApi::class)

package com.xtream.sharedResources.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.xtream.sharedResources.resources/"

@delegate:ResourceContentHash(441_829_000)
public val Res.font.metropolis_black: FontResource by lazy {
      FontResource("font:metropolis_black", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(871_935_269)
public val Res.font.metropolis_blackitalic: FontResource by lazy {
      FontResource("font:metropolis_blackitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_blackitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_907_497_744)
public val Res.font.metropolis_bold: FontResource by lazy {
      FontResource("font:metropolis_bold", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_820_282_397)
public val Res.font.metropolis_bolditalic: FontResource by lazy {
      FontResource("font:metropolis_bolditalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_bolditalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_646_649_210)
public val Res.font.metropolis_extrabold: FontResource by lazy {
      FontResource("font:metropolis_extrabold", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_extrabold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_141_568_804)
public val Res.font.metropolis_extrabolditalic: FontResource by lazy {
      FontResource("font:metropolis_extrabolditalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_extrabolditalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-141_506_502)
public val Res.font.metropolis_extralight: FontResource by lazy {
      FontResource("font:metropolis_extralight", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_extralight.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_745_663_253)
public val Res.font.metropolis_extralightitalic: FontResource by lazy {
      FontResource("font:metropolis_extralightitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_extralightitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_786_573_524)
public val Res.font.metropolis_light: FontResource by lazy {
      FontResource("font:metropolis_light", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(777_319_196)
public val Res.font.metropolis_lightitalic: FontResource by lazy {
      FontResource("font:metropolis_lightitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_lightitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_434_855_067)
public val Res.font.metropolis_medium: FontResource by lazy {
      FontResource("font:metropolis_medium", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_248_769_961)
public val Res.font.metropolis_mediumitalic: FontResource by lazy {
      FontResource("font:metropolis_mediumitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_mediumitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-945_087_594)
public val Res.font.metropolis_regular: FontResource by lazy {
      FontResource("font:metropolis_regular", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_081_172_544)
public val Res.font.metropolis_regularitalic: FontResource by lazy {
      FontResource("font:metropolis_regularitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_regularitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-791_197_661)
public val Res.font.metropolis_semibold: FontResource by lazy {
      FontResource("font:metropolis_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_780_056_967)
public val Res.font.metropolis_semibolditalic: FontResource by lazy {
      FontResource("font:metropolis_semibolditalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_semibolditalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(982_706_421)
public val Res.font.metropolis_thin: FontResource by lazy {
      FontResource("font:metropolis_thin", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_thin.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_741_847_923)
public val Res.font.metropolis_thinitalic: FontResource by lazy {
      FontResource("font:metropolis_thinitalic", setOf(
        ResourceItem(setOf(), "${MD}font/metropolis_thinitalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_385_290_022)
public val Res.font.noto_naskh_arabic_regular: FontResource by lazy {
      FontResource("font:noto_naskh_arabic_regular", setOf(
        ResourceItem(setOf(), "${MD}font/noto_naskh_arabic_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("metropolis_black", Res.font.metropolis_black)
  map.put("metropolis_blackitalic", Res.font.metropolis_blackitalic)
  map.put("metropolis_bold", Res.font.metropolis_bold)
  map.put("metropolis_bolditalic", Res.font.metropolis_bolditalic)
  map.put("metropolis_extrabold", Res.font.metropolis_extrabold)
  map.put("metropolis_extrabolditalic", Res.font.metropolis_extrabolditalic)
  map.put("metropolis_extralight", Res.font.metropolis_extralight)
  map.put("metropolis_extralightitalic", Res.font.metropolis_extralightitalic)
  map.put("metropolis_light", Res.font.metropolis_light)
  map.put("metropolis_lightitalic", Res.font.metropolis_lightitalic)
  map.put("metropolis_medium", Res.font.metropolis_medium)
  map.put("metropolis_mediumitalic", Res.font.metropolis_mediumitalic)
  map.put("metropolis_regular", Res.font.metropolis_regular)
  map.put("metropolis_regularitalic", Res.font.metropolis_regularitalic)
  map.put("metropolis_semibold", Res.font.metropolis_semibold)
  map.put("metropolis_semibolditalic", Res.font.metropolis_semibolditalic)
  map.put("metropolis_thin", Res.font.metropolis_thin)
  map.put("metropolis_thinitalic", Res.font.metropolis_thinitalic)
  map.put("noto_naskh_arabic_regular", Res.font.noto_naskh_arabic_regular)
}
